<template>
  <v-container fluid>
    <div class="text-center">
      <span class="text-h5">{{
        DISPLAY_ITEM_TEXT[`${displayChart.chartId}`]
      }}</span>
    </div>
    <apexchart
      ref="dataChart"
      class="access-chart"
      type="bar"
      height="350"
      :options="options"
      :series="displayChart.dataSeries"
    >
    </apexchart>
  </v-container>
</template>
<script>
import { DISPLAY_ITEM_TEXT } from "@/common/constant.js";
export default {
  name: "ReportColumnChart",
  props: {
    displayChart: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      options: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "15%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [""],
        },
        yaxis: {
          title: {
            // text: '$ (thousands)'
          },
          labels: {
            show: true,
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              let nf = new Intl.NumberFormat("en-US");
              return nf.format(val);
            },
          },
        },
      },
      DISPLAY_ITEM_TEXT: DISPLAY_ITEM_TEXT,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
